import React, { Component } from 'react';
import PlaceholderWinsIllustration from './../../assets/placeholders/weekly_wins_placeholder.svg';

class PlaceholderObjectives extends Component {
  render() { 
    return ( 
      <div className="weekly-wins-placeholder">
        <img style={{width:'145px'}} src={PlaceholderWinsIllustration}/>
        <div className="subheader mt20">  
          Your organization has not created any Enterprise Objectives here yet. Once created, you will be able to link your own planned Actions with Enterprise Objectives.
        </div>
      </div>
    );
  }
}
 
export default PlaceholderObjectives;